<template>
  <div id="membersturn">
    <div class="header flex-between">
      <div class="header-text">
        <h1>会员转店\品牌顾问</h1>
      </div>
      <div class="header-button" style="display: flex; align-items: center">
        <el-button
          icon="el-icon-search"
          @click="SearchBtn"
          v-if="jurisdiction.search"
          >查询</el-button
        >
        <el-button
          icon="el-icon-notebook-2"
          @click="Seartesr"
          v-if="jurisdiction.apply"
          >会员转店申请</el-button
        >
        <el-button
          icon="el-icon-edit-outline"
          @click="ImprotExcel"
          v-if="jurisdiction.Import"
          >会员转店导入</el-button
        >
        <el-button
          v-if="jurisdiction.Import"
          icon="el-icon-download"
          @click="(downloadShow = true), getDownladList()"
          >下载导入结果</el-button
        >
      </div>
    </div>

    <!-- 会员转店申请弹窗 -->
    <div class="apply">
      <el-dialog
        title="会员转店\品牌顾问-转店-品牌顾问申请"
        :visible.sync="applyVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 30px; background-color: #ededed; line-height: 30px">
          <span style="margin-left: 20px; color: #6c6937">转店会员</span>
        </div>
        <div style="margin: 0 10px 0 10px">
          <!-- 查询表单 -->
          <div style="margin-top: 10px">
            <el-form size="mini" label-width="200px" :model="queryInfoList">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="会员卡号\会员姓名\手机号">
                    <el-input v-model="queryInfoList.search"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="待转会员所在区域">
                    <div class="flex-between">
                      <el-select
                        style="width: 100%"
                        v-model="queryInfoList.origRegionName"
                        @change="changeSelectCur"
                      >
                        <el-option
                          v-for="item in queryInfoList"
                          :key="item.id"
                          :label="item.lable"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                      <el-button
                        style="
                          width: 80px;
                          margin-left: 5px;
                          background-color: #f1f3dd;
                          color: #b6b388;
                        "
                        size="small"
                        icon="el-icon-search"
                        @click="Secharbtn"
                        >查询</el-button
                      >
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="待转会员所在门店">
                    <el-select
                      style="width: 100%"
                      placeholder=""
                      v-model="queryInfoList.newShopName"
                      @change="changeSelectList"
                    >
                      <el-option
                        v-for="item in Maxchar"
                        :key="item.id"
                        :label="item.lable"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="待转会员所品牌顾问">
                    <div class="flex-between">
                      <el-select
                        style="width: 100%"
                        placeholder=""
                        v-model="marcuetList.EmpID"
                      >
                        <el-option
                          v-for="item in marcuetList"
                          :key="item.EmpID"
                          :label="item.EmpName"
                          :value="item.EmpID"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <!-- 表格 -->
          <el-table
            class="table-style"
            size="mini"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              'text-align': 'center',
              color: '#6C6839',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTable"
            :data="memberqueryLister"
            tooltip-effect="dark"
            style="width: 100%; margin-top: 10px"
            @selection-change="selectionLineChangeHandle"
            v-loading="loadingg"
            v-el-table-infinite-scroll="loadd"
            infinite-scroll-disabled="onloadingg"
          >
            <el-table-column type="selection" width="45"> </el-table-column>
            <el-table-column prop="custName" label="顾客名称">
            </el-table-column>
            <el-table-column prop="cardNo" label="会员卡号"> </el-table-column>
            <el-table-column prop="levelName" label="顾客等级">
            </el-table-column>
            <el-table-column prop="mobile" label="移动电话"> </el-table-column>
            <el-table-column prop="regionName" label="转前所属区域">
            </el-table-column>
            <el-table-column prop="shopName" label="转前所属门店">
            </el-table-column>
            <el-table-column prop="serviceEmpName" label="当前维护人">
            </el-table-column>
            <el-table-column prop="custType" label="会员类型">
            </el-table-column>
            <el-table-column prop="lastSaleDate" label="最近购买日">
              <template slot-scope="scope">
                {{ scope.row.lastSaleDate | dateFormats }}
              </template>
            </el-table-column>
            <el-table-column prop="currYearAmount" label="今年消费金额">
            </el-table-column>
            <el-table-column prop="prevYearAmount" label="去年消费金额">
            </el-table-column>
            <el-table-column prop="availPoint" label="当前积分">
            </el-table-column>
          </el-table>
          <el-alert
            v-if="isMoress"
            type="warning"
            title="没有更多数据了"
            center
            show-icon
            :closable="false"
          ></el-alert>
        </div>
        <div style="height: 30px; background-color: #ededed; line-height: 30px">
          <span style="margin-left: 20px; color: #6c6937">转后的店铺</span>
        </div>
        <div style="margin: 0 10px 0 10px">
          <el-row>
            <el-form
              style="margin-top: 20px"
              :model="shopafter"
              size="mini"
              label-width="150px"
              :rules="rules"
              ref="ruleForm"
            >
              <el-col :span="12">
                <el-form-item label="目标区域" prop="regionyer">
                  <el-select
                    v-model="shopafter.regionyer"
                    placeholder=""
                    @change="Changeregion"
                  >
                    <el-option
                      v-for="item in shopafter"
                      :key="item.id"
                      :label="item.lable"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="目标店铺"
                  style="margin-left: 20px"
                  prop="newServiceOrgID"
                >
                  <el-select
                    v-model="shopafter.newServiceOrgID"
                    placeholder=""
                    @change="changeStores"
                  >
                    <el-option
                      v-for="item in updateMax"
                      :key="item.id"
                      :label="item.lable"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="待转会员所品牌顾问" prop="newServiceEmpID">
                  <el-select v-model="shopafter.newServiceEmpID" placeholder="">
                    <el-option
                      v-for="item in insex"
                      :key="item.EmpID"
                      :label="item.EmpName"
                      :value="item.EmpID"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deleteFormVisible = true"
            >会员转店\品牌顾问</el-button
          >
          <el-button @click="applyVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 查询框 -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form
          :label-position="labelPosition"
          label-width="200px"
          :model="queryInfo"
          size="mini"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item
                class="redItem"
                :inline="true"
                label="会员卡号\会员姓名\手机号"
              >
                <el-input
                  style="width: 70%"
                  v-model="queryInfo.search"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="转店时期从">
                <el-date-picker
                  v-model="queryInfo.createStartDay"
                  type="date"
                  placeholder="开始日期"
                  value-format="yyyy-MM-dd"
                  style="width: 70%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="至">
                <el-date-picker
                  v-model="queryInfo.createEndDay"
                  type="date"
                  placeholder="结束日期"
                  style="width: 70%"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="转店之后所属区域">
                <el-select
                  style="width: 70%"
                  v-model="queryInfo.newRegionID"
                  @change="changeSelectes"
                >
                  <el-option
                    v-for="item in Regioncax"
                    :key="item.id"
                    :label="item.lable"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="转店之后所属门店">
                <el-select style="width: 70%" v-model="queryInfo.newServiceOrg">
                  <el-option
                    v-for="item in Storsedes"
                    :key="item.id"
                    :label="item.lable"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="转店之前所属区域">
                <el-select
                  style="width: 70%"
                  v-model="queryInfo.origRegionID"
                  @change="changeSelect"
                >
                  <el-option
                    v-for="item in Regioncax"
                    :key="item.id"
                    :label="item.lable"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="转店之前所属门店">
                <el-select
                  style="width: 70%"
                  v-model="queryInfo.origServiceOrg"
                >
                  <el-option
                    v-for="item in Storsed"
                    :key="item.id"
                    :label="item.lable"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never" class="centercard">
      <el-table
        class="table-style"
        border
        height="530px"
        size="small"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="tableData"
        v-loading="loading"
        v-el-table-infinite-scroll="load"
        infinite-scroll-disabled="onLoading"
      >
        <el-table-column label width="40">
          <template slot-scope="scope">
            <el-radio
              :label="scope.$index"
              v-model="radio1"
              @change.native="handleSelectionChange(scope.row)"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column prop="sheetNo" label="单据号"> </el-table-column>
        <el-table-column prop="custName" label="顾客名称"> </el-table-column>
        <el-table-column prop="cardNo" label="会员卡号"> </el-table-column>
        <el-table-column prop="levelName" label="顾客等级"> </el-table-column>
        <el-table-column prop="mobile" label="移动电话"> </el-table-column>
        <el-table-column
          prop="origRegionName"
          label="转之前所属区域"
        ></el-table-column>
        <el-table-column prop="origShopName" label="转之前所属门店">
        </el-table-column>
        <el-table-column prop="origServiceEmpName" label="转之前维护人">
        </el-table-column>
        <el-table-column
          label="转之后所属区域"
          prop="newOrigRegionName"
        ></el-table-column>
        <el-table-column prop="newShopName" label="转之后所属门店">
        </el-table-column>
        <el-table-column prop="newServiceEmpName" label="转之后维护人">
        </el-table-column>
        <el-table-column prop="createUserName" label="创建人">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormat }}
          </template>
        </el-table-column>
      </el-table>

      <el-alert
        v-if="isMore"
        title="没有更多啦!"
        type="warning"
        center
        :closable="false"
      ></el-alert>
    </el-card>
    <!-- 合并会员对话框弹窗 -->
    <div class="delete">
      <el-dialog
        width="20%"
        title="转店转品牌顾问确认取消对话框"
        :visible.sync="deleteFormVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">转店转品牌顾问</span
            >会员信息?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="sbmuit">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 导入保存确认对话框 -->
    <div class="import">
      <el-dialog
        title="会员转店—会员转店导入"
        :visible.sync="MemberFreezeImport"
        :close-on-click-modal="false"
        width="40%"
      >
        <el-form
          size="mini"
          label-width="225px"
          ref="newUploadForm"
          enctype="multipart/form-data"
        >
          <el-form-item label="选择待导入会员文件">
            <div class="flex-start">
              <el-input
                style="width: 300px"
                v-model="filename"
                :readonly="true"
                placeholder="请选择文件名"
              >
              </el-input>
              <el-upload
                class="upload"
                action="#"
                :show-file-list="false"
                :on-change="Selectupload"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :auto-upload="false"
              >
                <el-button style="margin-left: 20px">选择文件</el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-download" @click="templatebtn"
            >下载模板</el-button
          >
        </span>
      </el-dialog>

      <!-- 会员消费等级—会员消费等级调整-导入下载弹窗
      <div class="import">
        <el-dialog title="会员转店—会员转店导入"
                   :visible.sync="defaultisderived"
                   :close-on-click-modal="false"
                   width="40%">
          <div class="resui">
            <span>成功处理行数:{{ successUrl.sucNum }} </span>
            <span>失败处理行数:{{ successUrl.errNum }}</span>
            <span>处理结果文件:
              <a :href="successUrl.fileUrl">{{ successUrl.fileUrl }}</a>
              <el-button icon="el-icon-download"
                         style="margin-left: 10px"
                         @click="downloadbtn(successUrl.fileUrl)">下载</el-button>
            </span>
          </div>
        </el-dialog>
      </div> -->
    </div>
    <!-- 下载弹窗 -->
    <el-dialog
      append-to-body
      width="50%"
      :visible.sync="downloadShow"
      title="下载导入结果"
    >
      <el-table
        size="small"
        class="table-style"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="downloadData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <!-- v-loading="loading"
        v-el-table-infinite-scroll="load"
        infinite-scroll-disabled="onLoading" -->
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column
          prop="startTime"
          label="导入开始时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="导入结束时间"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-download"
              v-if="scope.row.isComplate"
              @click="download(scope.row.downloadUrl)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadShow = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryServiceChgRequestLisApi,
  selectEmpes,
  updateServiceApi,
  updataExlsx,
} from "@/api/user";
import { reportFormList } from "@/api/reportForm";
import { regionalQuery, Usermembers } from "@/api/huiyuanyy";

export default {
  name: "centre",
  data() {
    return {
      downloadData: [],
      downloadShow: false,
      loadingg: false,
      filename: "",
      custID: [],
      radio1: "",
      //展开文字
      text: "点击展开",
      showSearch: false,
      showAll: true, //是否展开全部
      applyVisible: false,
      // isMore: false,
      loading: false,
      deleteFormVisible: false,
      MemberFreezeImport: false,
      // defaultisderived: false,
      labelPosition: "right",
      //所属门店数据
      Storsed: [], //转之前
      Storsedes: [],
      handleSelectionValue: [], // 选中值
      size: 0,

      currentPage: 1, //默认开始页面
      pagesize: 0, //每页的数据条数
      tableData: [], //列表数据

      // viptableData: [], //会员列表查询
      // newTableData: [], //滚动加载新数据
      // newCool: [], //品牌顾问滚动加载数据
      Regioncax: {}, //区域数据存放
      memberqueryLister: [],

      //选择会员会员列表查询请求参数
      formInline: "",
      // 请求参数
      queryInfo: {
        pageNo: 1,
        pageSize: 50,
        search: "", //搜索
        pages: 0,
        origRegionID: "", //转之前区域
        origServiceOrg: "", //转之前门店
        newRegionID: "", //转之后区域
        newServiceOrg: "", //转之后门店
        createStartDay: "", //转店时期开始
        createEndDay: "", //转店时期
      },

      queryInfoList: {
        search: "", //搜索
        origRegionName: "", //转之前区域
        origShopName: "", //转之前门店
        newRegionID: "", //转之后区域
        newShopName: "", //转之后门店
        EmpID: "", //顾客id
      },
      //门店存放
      Maxchar: [],
      //顾问存放数据
      marcuetList: [],
      //关联赋值顾问
      insetcar: "",
      // 会员转店申请列表
      //转店后
      shopafter: {
        newServiceOrgID: "", //目标店铺
        newServiceEmpID: "", //目标品牌顾问
        regionyer: "", //目标区域
      },
      updateMax: [],
      insex: [],
      indexSer: "",
      //下载成功之后赋值数据
      successUrl: {},
      count: 1,
      jurisdiction: {
        search: false,
        apply: false,
        Import: false,
      },
      queryinfoqqq: {
        pageNo: 1,
        pageSize: 50,
        pages: 0,
      },
      rules: {
        regionyer: [
          { required: true, message: "请选择目标区域", trigger: "change" },
        ],
        newServiceOrgID: [
          { required: true, message: "请选择目标店铺", trigger: "change" },
        ],
        newServiceEmpID: [
          {
            required: true,
            message: "请选择待转会员所品牌顾问",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    let MembersTurn = JSON.parse(localStorage.getItem("MembersTurn"));
    for (let i = 0; i < MembersTurn.length; i++) {
      if (MembersTurn[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (MembersTurn[i].menuName == "会员转店申请") {
        this.jurisdiction.apply = true;
        continue;
      }
      if (MembersTurn[i].menuName == "会员转店导入") {
        this.jurisdiction.Import = true;
        continue;
      }
    }
    this.regioNalinformation();
    this.viewMembers();
  },
  computed: {
    isMoress() {
      //当起始页数等于总页数时停止加载
      return this.queryinfoqqq.pageNo >= this.queryinfoqqq.pages;
    },
    onloadingg() {
      return this.loadingg || this.isMoress;
    },
    isMore() {
      return this.queryInfo.pageNo >= this.queryInfo.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
  },
  methods: {
    //获取下载列表数据
    getDownladList() {
      reportFormList({
        groupName: "会员转店导入",
      }).then((response) => {
        console.log(response);
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = process.env.VUE_APP_BASE_API + src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    handleSelectionChange(val) {
      this.handleSelectionValue = val;
    },
    // 列表数据
    async viewMembers() {
      const { data: res } = await queryServiceChgRequestLisApi(this.queryInfo);
      if (this.queryInfo.pageNo == 1) this.tableData = [];
      this.tableData = this.tableData.concat(res.list);
      this.queryInfo.pages = res.pages;
      this.loading = false;
    },
    //会员管理初始化tabar表格滚动加载
    load() {
      this.loading = true;
      setTimeout(() => {
        this.queryInfo.pageNo += 1;
        this.viewMembers();
      }, 1000);
    },
    // 查询
    SearchBtn() {
      this.queryInfo.pageNo = 1;
      this.viewMembers();
    },
    //区域渲染数据
    async regioNalinformation() {
      const res = await regionalQuery({ regionID: "",state:1 });
      this.Regioncax = res.data;
      this.queryInfoList = res.data;
      this.shopafter = res.data;
    },
    //转之前关联区域到门店数据功能
    changeSelectCur() {
      for (let k in this.queryInfoList) {
        if (this.queryInfoList.origRegionName === this.queryInfoList[k].id) {
          this.Maxchar = this.queryInfoList[k].chlidren;
        }
      }
      // console.log(this.Maxchar);
    },
    //转之前关联数据功能
    changeSelect() {
      for (let k in this.Regioncax) {
        if (this.queryInfo.origRegionID === this.Regioncax[k].id) {
          this.Storsed = this.Regioncax[k].chlidren;
        }
      }
    },
    //转之后关联数据功能
    changeSelectes() {
      for (let k in this.Regioncax) {
        if (this.queryInfo.newRegionID === this.Regioncax[k].id) {
          this.Storsedes = this.Regioncax[k].chlidren;
        }
      }
    },
    //门店关联顾问
    changeSelectList(val) {
      this.insetcar = val;
      this.selectEmpList();
    },
    //点击显示会员转店申请
    Seartesr() {
      this.applyVisible = true;
      this.queryinfoqqq.pageNo = 1;
      this.memberqueryList();
      this.regioNalinformation();
      this.selectEmpList();
    },
    //选择会员信息获取
    async memberqueryList() {
      let data = {
        pageNo: this.queryinfoqqq.pageNo,
        pageSize: this.queryinfoqqq.pageSize,
        pages: this.queryinfoqqq.pages,
        search: this.queryInfoList.search,
        shopID: this.queryInfoList.newShopName,
        regionID: this.queryInfoList.origRegionName,
        empID: this.marcuetList.EmpID,
      };
      const res = await Usermembers(data);
      if (this.queryinfoqqq.pageNo == 1) this.memberqueryLister = [];
      this.memberqueryLister = this.memberqueryLister.concat(res.data.list);
      this.queryinfoqqq.pages = res.data.pages;
      this.loadingg = false;
    },
    loadd() {
      //滑到底部时进行加载
      this.loadingg = true;
      setTimeout(() => {
        this.queryinfoqqq.pageNo += 1;
        this.memberqueryList();
      }, 1000);
    },
    selectionLineChangeHandle(val) {
      this.custID = [];
      val.forEach((item) => {
        this.custID.push(item.custID);
      });
    },
    sbmuit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let Chaoku = {
            newServiceEmpID: this.shopafter.newServiceEmpID,
            custID: this.custID.toString(),
            newServiceOrgID: this.shopafter.newServiceOrgID,
          };
          updateServiceApi(Chaoku)
            .then((res) => {
              if (res.message === "success") {
                this.$message.success("操作成功!");
                this.deleteFormVisible = false;
                this.applyVisible = false;
                this.viewMembers();
              }
            })
            .catch((res) => {
              console.log(res);
              this.$message.error("操作失败");
            });
        }
      });
    },
    //会员转店\品牌顾问-转店-品牌顾问申请查询
    Secharbtn() {
      this.queryinfoqqq.pageNo = 1;
      this.memberqueryList();
    },
    //顾问接口
    async selectEmpList() {
      const res = await selectEmpes({ orgID: this.insetcar });
      this.marcuetList = res.data;
    },
    //区域转店之后关联
    Changeregion() {
      for (let k in this.shopafter) {
        if (this.shopafter.regionyer === this.shopafter[k].id) {
          this.updateMax = this.shopafter[k].chlidren;
        }
      }
    },
    //门店关联顾问
    changeStores(val) {
      this.indexSer = val;
      this.Consultantid();
    },
    async Consultantid() {
      const res = await selectEmpes({ orgID: this.indexSer });
      this.insex = res.data;
    },
    //导入Excel
    ImprotExcel() {
      this.MemberFreezeImport = true;
    },
    //下载模板
    templatebtn() {
      const ele = document.createElement("a");
      ele.style.display = "none";
      // 设置href属性为文件路径，download属性可以设置文件名称
      ele.href =
        process.env.VUE_APP_BASE_API + "/api/templates/会员转维护店模板.xlsx";
      ele.download = "";
      // 将a标签添加到页面并模拟点击
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      // 移除a标签
      ele.remove();
    },
    //下载导入后的模板
    // downloadbtn(url) {
    //   // console.log(url, '*****');
    //   const ele = document.createElement("a");
    //   ele.style.display = "none";
    //   // 设置href属性为文件路径，download属性可以设置文件名称
    //   ele.href = "https://gftest.redstone.com.cn/" + url;
    //   ele.download = "";
    //   // 将a标签添加到页面并模拟点击
    //   document.querySelectorAll("body")[0].appendChild(ele);
    //   ele.click();
    //   // 移除a标签
    //   ele.remove();
    // },
    //选择文件上传
    Selectupload(file) {
      let formData = new FormData(); //声明一个FormDate对象
      formData.append("file", file.raw); //把文件信息放入对象中
      // console.log(formData.get("file"));
      // const loading = this.$loading({
      //   lock: true,
      //   text: "导入中，请等待",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.5)",
      // });
      //调用后台导入的接口
      updataExlsx(formData)
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            // 导入表格之后可以获取导入的数据渲染到页面，此处的方法是获取导入的数据
          } else {
            // loading.close();
            this.$message.success("导入成功请在下载列表查看");
            // this.defaultisderived = true;
            // this.successUrl = res.data;
            this.MemberFreezeImport = false;
          }
        })
        .catch((err) => {
          console.log(err);
          // loading.close();
          this.$message({
            type: "error",
            message: "导入失败",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__footer {
  height: 60px;
  background-color: #f2f2f2;
}
#membersturn {
  // height: 1200px;
  height: 100%;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.centercard {
  margin-top: 10px;
}
.searchform {
  margin-top: 10px;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

.el-table .warning-row {
  background: #fcfbf2;
}

.el-table .success-row {
  background: #ffffff;
}
::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-dialog__header {
    background-color: #f3f1dd;
  }
  // 转店申请弹窗样式
  .apply {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 16px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 0 20px 0;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .import {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 10px 30px 20px 30px;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .resui {
    display: flex;
    flex-direction: column;
  }
  .resui span {
    line-height: 30px;
    font-size: 18px;
  }
}
</style>
